import React from 'react';

import Unauthenticated from 'Components/Layouts/Unauthenticated';
import { PrimaryButton } from "Components/Button";
import BigYellowButton from "Components/Button/BigYellowButton";
import TitleText from "Components/Utilities/TitleText";
import { Loading } from 'Components/Partials';

import ScoresApi from 'Services/Api/Site/Scores';

import { asset } from "Services/BaseHelpers";

export default class Leaderboard extends React.Component {
    /**
     * @var state
     */
    state = {
        loading: true,
        scores: null
    };

    /**
     * @method componentDidMount
     */
    componentDidMount() {
        this.loadScores();
    }

    /**
     * @method loadScores
     */
    loadScores = async () => {
        const response = await ScoresApi.get(null, {
            game_id: 'pacman_3',
            order_by: 'score',
            order: 'desc',
            limit: 10
        });

        this.setState({
            loading: false,
            scores: response?.data?.data
        });
    }

    /**
     * @method render
     * @return {*}
     */
    render () {
        const {loading, scores} = this.state;
        const {setParentState} = this.props;

        return (
            <div className="h-full overflow-y-auto">
                <TitleText 
                    subtitle="Top 10" 
                    title="Leaderboard"
                />

                <div className="mt-6 mb-8">
                    <BigYellowButton 
                        onClick={() => setParentState({
                            stage: 'how-to-play'
                        })}
                        text="New Game"
                    />
                </div>

                {loading && <Loading className="text-white" />}

                {!loading && (!scores || scores.length === 0) &&
                    <p className="text-xs md:text-base xl:text-lg rubik-regular text-app-yellow text-center mt-3 xl:mt-5 mb-8">
                        You are the first player!
                    </p>
                }

                {!loading && scores && scores.length !== 0 &&
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-8 mb-10">
                        {this.renderLeaderboard(scores.slice(0, 5), 1)}

                        {this.renderLeaderboard(scores.slice(5), 6)}
                    </div>
                }
            </div>
        );
    }

    /**
     * @method renderRank
     * @param {array} scores
     * @param {integer} addToIndex
     * @return {*}
     */
    renderLeaderboard(scores, addToIndex) {
        return (
            <div className="flex flex-col gap-4">
                {scores.map((score, i) => (
                    <div
                        className="flex flex-row items-center gap-3"
                        key={i}
                    >
                        {this.renderRank(i + addToIndex)}

                        <img
                            className="h-6 w-6 xl:h-8 xl:w-8"
                            src={asset('/images/pacman/profile.png')}
                        />
                        
                        <div className={`
                            w-full flex flex-row justify-between items-center gap-2 px-4 py-1 bg-app-turquoise
                            text-white retro-gaming uppercase rounded-md
                        `}>
                            <span className="text-md xl:text-lg tracking-wide">
                                {score.nickname}
                            </span>

                            <span className="text-xs xl:text-sm rubrik-regular">
                                {score.score}
                            </span>
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    /**
     * @method renderRank
     * @param {integer} rank
     * @return {*}
     */
    renderRank(rank) {
        switch(rank) {
            case 1:
                return <img
                    className="h-6 w-6 xl:h-8 xl:w-8"
                    src={asset('/images/pacman/1st.png')}
                />;
            case 2:
                return <img
                    className="h-6 w-6 xl:h-8 xl:w-8"
                    src={asset('/images/pacman/2nd.png')}
                />;
            case 3:
                return <img
                    className="h-6 w-6 xl:h-8 xl:w-8"
                    src={asset('/images/pacman/3rd.png')}
                />;
            default:
                return <div className="h-6 xl:h-8 w-6 xl:w-8 text-center text-md text-white retro-gaming">
                    {rank}
                </div>;
        }
    }
}
